<template>
    <b-modal ref="mdlLingueEdit" :title="'Aggiungi Lingia'" hide-header-close no-close-on-backdrop no-close-on-esc centered>
        <b-row>
            <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                <label class="sa-label_data">Codice</label>
                <b-form-input v-model="jsonData.codice"></b-form-input>
            </b-col>
            <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                <label class="sa-label_data">Lingua</label>
                <b-form-input v-model="jsonData.descrizione"></b-form-input>
            </b-col>
        </b-row>
        <template #modal-footer>
            <b-button size="md" variant="outline-danger" @click="onCloseModal">Annulla</b-button>
            <b-button size="md" variant="outline-success" @click="onClickOk()">Salva</b-button>
        </template>
        <modal-error ref="cmpModalError"></modal-error>
    </b-modal>
</template>

<script>
import ModalError from "../../../template/components/modal/components/ModalError.vue";
import UtilityMixin from "../../utility/UtilityMixin";
// import DatePicker from "vue2-datepicker";

export default {
    mixins: [UtilityMixin],
    components: { ModalError },
    data() {
        return {
            title: null,
            pathResource: "/lingue",
            pathResourceFlussiTipi: "/flussitipi",
            readOnly: false,
            jsonData: { codice: null, descrizione: null },
            lookPassword: false,
            flussiptions: [],
        };
    },
    methods: {
        show() {
            let me = this;
            me.jsonData = { codice: null, descrizione: null };
            me.loadTipiFlussi();
            me.$refs.mdlLingueEdit.show();
        },
        loadTipiFlussi() {
            let me = this;
            me.flussiptions = [];
            UtilityMixin.methods.loadDataResources(me.pathResourceFlussiTipi, null, me.loadTipiFlussiSuccess, me.loadTipiFlussiError);
        },
        loadTipiFlussiSuccess(response) {
            let me = this;
            me.flussiptions = response.data.data.list;
        },
        loadTipiFlussiError(response) {
            let me = this;
            me.$emit("afterLoadData", response);
            me.$bvToast.toast("Errore durante il caricamento", {
                title: "Errore",
                variant: "danger",
                solid: true,
            });
        },
        onCloseModal() {
            let me = this;
            me.jsonData = {};
            me.$refs.mdlLingueEdit.hide();
        },
        onClickOk() {
            let me = this;
            UtilityMixin.methods.saveResource(me.pathResource, me.jsonData, me.saveResponseSuccess, me.saveResponseError);
        },
        saveResponseSuccess(response) {
            let me = this;
            me.$refs.mdlLingueEdit.hide();
            me.$bvToast.toast("Operazione andata a buon fine", {
                title: "Successo",
                variant: "Success",
                solid: true,
            });
            me.$emit("afterSave", response);
        },

        saveResponseError(error) {
            let me = this;
            me.$refs.cmpModalError.show(error.response.data.messaggio);
        },
    },
};
</script>

<style></style>
